import { render, staticRenderFns } from "./ReportsModule.vue?vue&type=template&id=61651eec"
import script from "./ReportsModule.vue?vue&type=script&lang=js"
export * from "./ReportsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports